export var importQuoteInsuranceProductMap = {
  axa: {
    value: 'axa',
    label: 'AXA'
  },
  allianz: {
    value: 'allianz',
    label: 'Allianz'
  },
  hiscox: {
    value: 'hiscox',
    label: 'Hiscox'
  },
  markel: {
    value: 'markel',
    label: 'Markel'
  },
  accelerant: {
    value: 'accelerant',
    label: 'Accelerant'
  },
  msAmlin: {
    value: 'msAmlin',
    label: 'MS Amlin'
  },
  tokyoMarine: {
    value: 'tokyoMarine',
    label: 'Tokyo Marine'
  },
  other: {
    value: 'other',
    label: 'Other'
  }
};
export var importQuoteInsuranceProductList = Object.values(importQuoteInsuranceProductMap);